import { useEffect } from "react"

import { Divider, Flex, Typography } from "antd"
import { useDispatch, useSelector } from "react-redux"

import Private from "../../../../../Components/Private"
import ReferralActions from "../../../reducer"

import "./PaymentMethodDetailsModal.less"

const { Text } = Typography

const PaymentDetails = ({ paymentMethod, isMaskedBankDetails }) => {
  const dispatch = useDispatch()

  const { countryCodes } = useSelector((state) => state.referrals)

  useEffect(() => {
    if (!countryCodes) {
      dispatch(ReferralActions.getCountryCodesRequest())
    }
  }, [])

  const bankAccountIdentifier = isMaskedBankDetails
    ? paymentMethod?.masked_identifier
    : paymentMethod?.country === "US"
      ? paymentMethod?.account_number
      : paymentMethod?.iban

  return (
    <div className="payment-method-details">
      <Flex gap={16} vertical>
        <Text className="sub-title">Bank account details</Text>
        <Flex gap={12}>
          <Flex gap={4} vertical flex="1">
            <Text type="secondary">Company name</Text>
            <Text>
              <Private>{paymentMethod?.company_name ?? "-"}</Private>
            </Text>
          </Flex>
          <Flex gap={4} vertical flex="1">
            <Text type="secondary">Currency</Text>
            <Text>USD</Text>
          </Flex>
        </Flex>
        <Flex gap={12}>
          <Flex gap={4} vertical flex="1">
            <Text type="secondary">
              {paymentMethod?.country === "US" ? "Account number" : "IBAN"}
            </Text>
            <Text>
              <Private>{bankAccountIdentifier ?? "-"}</Private>
            </Text>
          </Flex>

          <Flex gap={4} vertical flex="1">
            <Text type="secondary">Account holder name</Text>
            <Text>
              <Private>{paymentMethod?.account_holder_name ?? "-"}</Private>
            </Text>
          </Flex>
        </Flex>
        <Flex gap={12}>
          <Flex gap={4} vertical flex="1">
            <Text type="secondary">SWIFT code</Text>
            <Text>
              <Private>{paymentMethod?.swift_code ?? "-"}</Private>
            </Text>
          </Flex>
          <Flex gap={4} vertical flex="1">
            <Text type="secondary">Country/region</Text>
            <Text>{countryCodes?.[paymentMethod?.country] ?? "-"}</Text>
          </Flex>
        </Flex>
      </Flex>
      <Divider />
      <Flex gap={16} vertical>
        <Text className="sub-title">Contact address</Text>
        <Flex gap={12}>
          <Flex gap={4} vertical flex="1">
            <Text type="secondary">Country of residence</Text>
            <Text>{countryCodes?.[paymentMethod?.residence_country] ?? "-"}</Text>
          </Flex>
          <Flex gap={4} vertical flex="1">
            <Text type="secondary">Town/City</Text>
            <Text>{paymentMethod?.city ?? "-"}</Text>
          </Flex>
        </Flex>
        <Flex gap={12}>
          <Flex gap={4} vertical flex="1">
            <Text type="secondary">Street</Text>
            <Text>{paymentMethod?.street ?? "-"}</Text>
          </Flex>
          <Flex gap={4} vertical flex="1">
            <Text type="secondary">Postcode</Text>
            <Text>{paymentMethod?.postcode ?? "-"}</Text>
          </Flex>
        </Flex>
      </Flex>
    </div>
  )
}

export default PaymentDetails
